import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Facebook, Instagram, Heart } from 'lucide-react';
import { Separator } from './ui/separator';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleNavClick = (link) => {
    if (link.path === '/galerie') {
      navigate('/galerie');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (link.path === '/' && !isHomePage) {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(link.href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector(link.href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const footerLinks = [
    { name: 'Accueil', href: '#hero', path: '/' },
    { name: 'Menu', href: '#menu', path: '/' },
    { name: 'Galerie', href: '/galerie', path: '/galerie' },
    { name: 'Contact', href: '#contact', path: '/' },
  ];

  return (
    <footer className="bg-accent text-accent-foreground">
      <div className="container mx-auto px-4 sm:px-6 py-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_page-builder-55/artifacts/ptld52ee_295233728_472735281522011_7002067538974660912_n.png"
                alt="P&G Pizza & Gourmandises"
                className="h-16 w-auto"
              />
              <div className="font-display text-3xl text-secondary">P&G</div>
            </div>
            <p className="text-accent-foreground/80 text-sm leading-relaxed mb-4">
              Pizza & Gourmandises - Burgers artisanaux et pizzas authentiques depuis 2015
            </p>
            <div className="flex space-x-3">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-accent-foreground/10 hover:bg-primary/20 flex items-center justify-center transition-smooth"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-accent-foreground" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-accent-foreground/10 hover:bg-primary/20 flex items-center justify-center transition-smooth"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-accent-foreground" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-accent-foreground">Liens Rapides</h3>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => handleNavClick(link)}
                    className="text-accent-foreground/80 hover:text-secondary transition-smooth text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-accent-foreground">Contact</h3>
            <div className="space-y-2 text-sm text-accent-foreground/80">
              <p>35 rue Hervé de Guébriant</p>
              <p>29800 Landerneau</p>
              <p className="mt-3">
                <a href="tel:0298801612" className="hover:text-secondary transition-smooth">
                  02 98 80 16 12
                </a>
              </p>
            </div>
          </div>
        </div>

        <Separator className="bg-accent-foreground/20 my-8" />

        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <p className="text-sm text-accent-foreground/70 text-center sm:text-left">
            © {currentYear} P&G Pizza & Gourmandises. Tous droits réservés.
          </p>
          <div className="text-sm text-accent-foreground/70 flex items-center">
            Fait avec <Heart className="w-4 h-4 mx-1 text-primary fill-primary" /> à Landerneau
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;